import Colors from 'components/tokens/Colors';
import styled, { css } from 'styled-components';
import { renderBreakPoints } from '../Grid';

const Link = styled.a`
    color: ${Colors.black};
    text-decoration: ${props => (props.decoration ? props.decoration : 'underline')};

    ${props =>
        props.upper &&
        css`
            text-transform: uppercase;
        `}
    font-weight: ${props => (props.weight ? props.weight : 700)};

    ${props => {
        let sizes = props.fontSize ? props.fontSize.split(' ') : ['16'];
        return renderBreakPoints(k => {
            if (!sizes[k]) return;

            return css`
                font-size: ${parseInt(sizes[k], 10) / 10}rem;
                line-height: ${(parseInt(sizes[k], 10) / 10) * 1.2}rem;
            `;
        });
    }}

    ${props => {
        if (!props.lineHeight) return;

        let lineHeight = props.lineHeight.split(' ');
        return renderBreakPoints(k => {
            if (!lineHeight[k]) return;

            return css`
                line-height: ${parseInt(lineHeight[k], 10) / 10}rem;
            `;
        });
    }}

    &:hover {
        text-decoration: none;
    }

    &:hover,
    &:visited {
        color: ${Colors.black};
    }

    ${props =>
        props.color &&
        css`
            color: ${props.color};
            &:hover,
            &:visited {
                color: ${props.color};
            }
        `}
`;

export default Link;
